import { OrdersService } from "@/services/nextshop/orders.service";
import _ from "lodash"

export default {
  data() {
    return {};
  },
  methods: {
    checkIsEnoughImeiAndProductBatch(lineItemMerge) {
      let isImeiEnough = true;
      let isProductBatchEnough = true;

      lineItemMerge.forEach((e) => {
        // check imei
        e.useImeiAndSerial && e.seriesNoTmp.length != e.quantity ? (isImeiEnough = false) : "";

        // check lô
        if (e.useProductBatch) {
          let totalQuantity = 0;
          e.batchTmp.map((item) => {
            // console.log(item);
            totalQuantity += +item.quantityVal;
          });
          if (totalQuantity != e.quantity) isProductBatchEnough = false;
          // console.log({ totalQuantity, quantity: e.quantity });
        }
      });
      if (isImeiEnough && isProductBatchEnough) return true
      else return false
    },

    async confirmCheckoutMixin({ isNotShowSuccess }, lineItemMerge, itemId ) {
      // console.log(isNotShowSuccess, lineItemMerge, itemId);
      // return false
      let lineItemResult = [];
      lineItemMerge.map((e) => {
        if (e.seriesNoTmp && e.seriesNoTmp.length > 0) {
          e.lineItemOtherInfo.seriesNo = JSON.stringify(e.seriesNoTmp);
        }
      });
      const id = itemId;
      lineItemResult = this.splitLineItemLoHsd(_.cloneDeep(lineItemMerge));
      // console.log(33333,lineItemResult)
      // return

      if (id) {
        this.loading = true;
        try {
          const params = {
            orderId: id,
            lineItem: lineItemResult,
          };
          const response = await OrdersService.confirmCheckout(params);
          // console.log(123, response )
          if (response.success) {
            if (isNotShowSuccess) {
              // await this.fetchData()
              return true;
            }
            this.showExportOrder = false;
            this.showSwalSuccess("Xuất kho");
            this.fetchData();
            return true;
          } else {
            this.showSwalError("Xuất kho", response.message);
            return false;
          }
        } catch (error) {
          console.log(error)
          this.showNotify("Xuất kho",error,"error")
          return false;
        } finally {
          this.loading = false;
        }
      }
    },


    splitLineItemLoHsd(lineItemTemp) {
      let splitLineItemLoHsd = [];
      let spliceItem = [];
      lineItemTemp.map((item) => {
        if (item.useProductBatch) {
          let lineItemTmp = [];
          if (item.batchTmp && item.batchTmp.length > 0) {
            item.batchTmp.map(async (val, index) => {
              lineItemTmp[index] = JSON.parse(JSON.stringify(item));
              const batchCodeItem = {
                batchCode: val.batchCode,
                quantity: val.quantityVal,
                manufactureDate: val.manufactureDate,
                expirationDate: val.expirationDate,
                type: "NSH_ITEM_SALE",
              };
              lineItemTmp[index].lineItemOtherInfo.productBatch = JSON.stringify(batchCodeItem);
              lineItemTmp[index].totalAmount = val.quantityVal * (lineItemTmp[index].totalAmount / lineItemTmp[index].quantity);
              lineItemTmp[index].amount = val.quantityVal * (lineItemTmp[index].amount / lineItemTmp[index].quantity);
              lineItemTmp[index].quantity = val.quantityVal;
            });

            if (lineItemTmp.length > 0) {
              splitLineItemLoHsd.push(...lineItemTmp);
              spliceItem.push(item.lineItemId);
            }
          }
        }
      });

      if (spliceItem.length > 0) {
        spliceItem.map((item) => {
          const getIndex = lineItemTemp.findIndex((val) => val.lineItemId === item);
          if (getIndex != -1) {
            lineItemTemp.splice(getIndex, 1);
          }
        });
        if (splitLineItemLoHsd.length > 0) {
          lineItemTemp.push(...splitLineItemLoHsd);
        }
      }

      return lineItemTemp;
    },
  },
};
